import { useEffect } from 'react';

interface IUseFullScreen {
  fullScreenChange: () => void;
}
export default function(props: IUseFullScreen) {
  const { fullScreenChange } = props;
  // 全屏事件监听
  useEffect(() => {
    [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange'
    ].forEach(event => {
      document.addEventListener(event, fullScreenChange);
    });
    return () => {
      [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
      ].forEach(event => {
        document.removeEventListener(event, fullScreenChange);
      });
    };
  }, []);
}
